import Helper from './Helper';

class Animate {

  constructor() {
    console.log('ok')

    let s = [
      '.content > .ns-title-h1',
      '.content > .ns-title-h2',
      '.content > .ns-title-h3',
      '.content > .ns-title-h4',
      '.content > .ns-title-h5',
      '.content > .ns-title-h6',
      '.content > .ns-lead',
      '.content > .ns-paragraph',
      '.content > .ns-list-group',
      '.content > .ns-table-wrap',
      '.content > .ns-img',
      '.content > .ns-cv',
      '.content > .ns-signature',
      '.content > .ns-quote',
      '.content > .ns-img-two-texts',
      '.content > .ns-marginal-container',
      '.content > .ns-gray-container',
      '.ns-highlight',
      '.content > .ns-quote-front',
      '.content > .ns-anchor-front__link',
      '.ns-list-group > .ns-list-group__item',
      '.content > .ns-marginal-container'
    ]

    const selectors = s.join(',');

    const hashtag = window.location.hash;

    if(hashtag && hashtag != '#') {
      setTimeout(() => {
        window.scrollTo(0,0);
      },1);

      setTimeout(() => {
        const headerHeight = document.querySelector('.header').clientHeight;
        const breadcrumbHeight = document.querySelector('.breadcrumbs').clientHeight;
        const adminbarHeight = document.querySelector('body').classList.contains('admin-bar') ? document.querySelector('.header').offsetTop : 0;
        const yOffset = -1 * (headerHeight + breadcrumbHeight + adminbarHeight + 30);
        const element = document.querySelector(hashtag);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
      }, 1000);
    }

    const elements = Array.prototype.slice.call(document.querySelectorAll(selectors));
    elements.forEach(e => {
      if (!Helper.jizzInViewport(e)) {
        e.classList.add('animate');
      } else {
        e.classList.add('animate');
        e.classList.add('animated');
      }
      Helper.loadImagesInDomElement(e);
    });

    document.addEventListener('notesopen', () => {
      this.animateInPopup(selectors);
    });

    this.handleScroll(elements);

    window.addEventListener("scroll", e => {
      this.handleScroll(elements);
    });
  }

  handleScroll(elements){
    elements.forEach(e => {
      if(Helper.jizzInViewport(e)){
        e.classList.add('animated');
      }
    });
  }

  animateInPopup(selectors) {
      const elements = Array.prototype.slice.call(document.querySelectorAll(selectors));
      elements.forEach(e => {
        e.classList.add('animate');
        e.classList.add('animated');
        Helper.loadImagesInDomElement(e);
      });
  }
}
export default Animate;
